<app-loader *ngIf="loader"></app-loader>
<div *ngIf="!loader">
    <div class="ui-g">
        <div class="ui-g-12">  
            <button (click)="location.back()" pButton type="button" icon="pi pi-chevron-left" class="ui-button-info" style="margin-right: 20px;" label="{{ 'back_btn' | translate }}"></button>       
            <h3 style="display: inline-block;" class="section-header">{{ 'editing' | translate }}: {{ pageDesc | translate }}</h3>
        </div>
    </div>
    <quill-editor [(ngModel)]="pageContent" [style]="{'height':'320px'}" [disabled]="!isEditing"> </quill-editor>     
    <button *ngIf="!isEditing" (click)="onStartEditing()" pButton type="button" label="{{ 'edit' | translate }}" class="ui-button-info"  style="width: 100%;"></button>
    <button *ngIf="isEditing" (click)="onConfirmEditing()" pButton type="button" label="{{ 'save' | translate }}" class="ui-button-success"  style="width: 50%;"></button>
    <button *ngIf="isEditing" (click)="onCancelEditing()" pButton type="button" label="{{ 'cancel' | translate }}" class="ui-button-warning"  style="width: 50%;"></button>
</div>
